import { message, Spin } from 'antd';
import { useJanusContext } from 'Context/JanusContext';
import { useEffect, useRef, useState } from 'react';
import Webcam from 'react-webcam';
import { useSetVideoRecordingTest } from 'ServiceHooks/interviewHooks';
import 'Styles/commonStyles.scss';
import VoiceWaveBars from './VoiceWaveBars';

const AITestRecording = ({
  // videoRef,
  setVideoStreamTest,
  setRecordingModalOpen,
}) => {
  const { recordingId, stopRecording, startRecording } = useJanusContext();
  const [stream, setStream] = useState(null);
  const [videoStream, setVideoStream] = useState(null);
  const [isTestStart, setTestStart] = useState(false);
  const [messageApi, messageContextHolder] = message.useMessage();
  const [recorded_video, setRecordedVideo] = useState(null);
  const videoRef = useRef(null);
  const [isWebcamOn, setIsWebcamOn] = useState(true);
  const [videoDeviceList, setVideoDeviceList] = useState([]);
  const [audioDeviceList, setAudioDeviceList] = useState([]);
  const [selectedVideoDevice, setSelectedVideoDevice] = useState('');
  const [selectedAudioDevice, setSelectedAudioDevice] = useState('');

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then((deviceInfos) => {
      const videoDevices = deviceInfos.filter(
        (device) => device.kind === 'videoinput',
      );
      const audioDevices = deviceInfos.filter(
        (device) => device.kind === 'audioinput',
      );

      setVideoDeviceList(videoDevices);
      setAudioDeviceList(audioDevices);

      // Set default selected devices
      if (videoDevices.length > 0)
        setSelectedVideoDevice(videoDevices[0].deviceId);
      if (audioDevices.length > 0)
        setSelectedAudioDevice(audioDevices[0].deviceId);
    });
  }, []);

  console.log(videoDeviceList, 'videoDeviceList', audioDeviceList);

  useEffect(() => {
    // Add audio to video stream after a short delay
    if (videoStream) {
      const delay = setTimeout(() => {
        navigator.mediaDevices
          .getUserMedia({
            audio: { echoCancellation: true, noiseSuppression: true },
          })
          .then((audioStream) => {
            const videoTrack = videoStream.getVideoTracks()[0];
            const combinedTracks = new MediaStream([
              ...audioStream.getTracks(),
              videoTrack,
            ]);
            console.log(combinedTracks, 'combinedTracks');
            setStream(combinedTracks);
          })
          .catch((error) => {
            console.error('Error accessing audio:', error);
          });
      }, 100); // 100ms delay

      return () => clearTimeout(delay);
    }
  }, [videoStream]);

  const { mutateAsync: checkRecording, isLoading } =
    useSetVideoRecordingTest({
      onSuccess: async (data) => {
        console.log(data, 'datadatadatadata');
        if (data?.success) {
          setRecordedVideo(data?.data?.video_url);
          setVideoStreamTest(true);
          // setRecordingModalOpen(false)
          messageApi.open({
            type: 'success',
            content: 'Video Stream Recorded Successfully',
          });
        }
      },
      onError: (error, variables, context) => {
        console.log(error, 'errorerrorerror');
      },
    });

  const recordStream = async () => {
    setIsWebcamOn(true);
    setRecordedVideo(null);
    if (stream) {
      setTestStart(true);
      await startRecording(stream);
      // await new Promise((resolve) => setTimeout(resolve, 5000));
    }
  };

  const stopWebcam = () => {
    setIsWebcamOn(false);
    if (videoStream) {
      videoStream.getTracks().forEach((track) => track.stop());
      setVideoStream(null);
    }
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null);
    }
  };

  const checkRecrdingTest = async () => {
    console.log(recordingId, 'recordingIdrecordingId');
    if (recordingId) {
      const body = { recording_id: recordingId };
      try {
        await checkRecording({ body });
      } catch (err) {
        setIsWebcamOn(true)
        messageApi.open({
          type: 'error',
          content: err?.response?.data?.error_info?.message,
        });
      }
      await stopRecording();
      setTestStart(false);
      stopWebcam();
    }
  };

  const showLoader = () => {
    return (
      <div className="h-[20rem] flex items-center justify-center">
        <Spin
          tip="Please Wait"
          size="large"
          fullscreen
          className="text-[#04D0C7] text-lg font-semibold"
        >
          Video is Checking...
        </Spin>
      </div>
    );
  };

  console.log(isWebcamOn, 'isWebcamOnisWebcamOnisWebcamOn');
  return (
    <div className="py-8">
      {messageContextHolder}

      <div>
        <div className="flex items-center mb-2 justify-between">
          <span className="text-[#5B5B5B] font-semibold">Camera</span>
          <select
            onChange={(e) => setSelectedVideoDevice(e.target.value)}
            value={selectedVideoDevice}
            className="w-1/2"
          >
            {videoDeviceList.map((device) => (
              <option key={device.deviceId} value={device.deviceId}>
                {device.label ||
                  `Camera ${videoDeviceList.indexOf(device) + 1}`}
              </option>
            ))}
          </select>
        </div>
        <div className="flex flex-col items-center justify-between">
          {recorded_video ? (
            <video
              className="w-full h-full"
              controls
              controlsList="nodownload"
              onContextMenu={(e) => e.preventDefault()}
              mirrored
            >
              <source src={recorded_video} type="video/mp4" />
              <source src={recorded_video} type="video/ogg" />
              Your browser does not support the video tag.
            </video>
          ) : isLoading ? (
            showLoader()
          ) : (
            isWebcamOn && (
              <Webcam
                ref={videoRef}
                playsInline
                muted
                mirrored
                screenshotFormat="image/jpeg"
                videoConstraints={{
                  width: 1280,
                  height: 600,
                  facingMode: { ideal: 'user' },
                  deviceId: selectedVideoDevice,
                }}
                audioConstraints={{ deviceId: selectedAudioDevice }}
                className="object-cover rounded"
                onUserMedia={(stream) => {
                  console.log(stream, 'stream inside webcam');
                  setVideoStream(stream);
                }}
              />
            )
          )}

          <div className="opacity-25 bg-[#7F7A7A] p-[1px] my-4 w-full"></div>
        </div>
      </div>
      <div>
        <div className="flex items-center mb-5 justify-between">
          <span className="text-[#5B5B5B] font-semibold">Microphone</span>
          <select
            onChange={(e) => setSelectedAudioDevice(e.target.value)}
            value={selectedAudioDevice}
            className="w-1/2"
          >
            {audioDeviceList.map((device) => (
              <option key={device.deviceId} value={device.deviceId}>
                {device.label ||
                  `Microphone ${audioDeviceList.indexOf(device) + 1}`}
              </option>
            ))}
          </select>
        </div>
        <VoiceWaveBars />
        <div className="w-full flex items-center justify-center mt-6">
          <button
            onClick={() =>
              isTestStart ? checkRecrdingTest() : recordStream()
            }
            className={`px-4 py-2 flex items-center gap-2 rounded-3xl ${isTestStart ? 'bg-[#FF8C52]' : 'bg-[#11B2AB]'} text-[#FFF] text-sm font-medium`}
          >
            {isTestStart ? (
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.92114 1.1864C3.30406 1.1864 1.18249 3.30797 1.18249 5.92505C1.18249 8.54212 3.30406 10.6637 5.92114 10.6637C8.53821 10.6637 10.6598 8.54212 10.6598 5.92505C10.6598 3.30797 8.53821 1.1864 5.92114 1.1864ZM0.414062 5.92505C0.414062 2.88357 2.87967 0.417969 5.92114 0.417969C8.96264 0.417969 11.4282 2.88357 11.4282 5.92505C11.4282 8.96655 8.96264 11.4321 5.92114 11.4321C2.87967 11.4321 0.414062 8.96655 0.414062 5.92505ZM5.8945 3.49169H5.94778C6.40807 3.49167 6.79188 3.49166 7.09658 3.53262C7.4182 3.57587 7.70856 3.67098 7.94186 3.90431C8.1752 4.13765 8.27033 4.42801 8.31357 4.74962C8.35455 5.05432 8.3545 5.43812 8.3545 5.89841V5.95169C8.3545 6.41198 8.35455 6.79578 8.31357 7.10049C8.27033 7.4221 8.1752 7.71247 7.94186 7.94576C7.70856 8.17911 7.4182 8.27424 7.09658 8.31748C6.79188 8.35846 6.40807 8.35841 5.94778 8.35841H5.8945C5.43421 8.35841 5.05041 8.35846 4.74571 8.31748C4.4241 8.27424 4.13374 8.17911 3.90041 7.94576C3.66708 7.71247 3.57196 7.4221 3.52872 7.10049C3.48776 6.79578 3.48777 6.41198 3.48778 5.95169V5.89841C3.48777 5.43812 3.48776 5.05432 3.52872 4.74962C3.57196 4.42801 3.66708 4.13765 3.90041 3.90431C4.13374 3.67098 4.4241 3.57587 4.74571 3.53262C5.05041 3.49166 5.43421 3.49167 5.8945 3.49169ZM4.8481 4.29421C4.6117 4.32599 4.51053 4.38092 4.44377 4.44768C4.37701 4.51443 4.32208 4.61561 4.2903 4.85201C4.25703 5.09945 4.25621 5.4312 4.25621 5.92505C4.25621 6.41889 4.25703 6.75065 4.2903 6.99808C4.32208 7.2345 4.37701 7.33568 4.44377 7.40243C4.51053 7.46918 4.6117 7.5241 4.8481 7.55591C5.09554 7.58916 5.4273 7.58998 5.92114 7.58998C6.41499 7.58998 6.74674 7.58916 6.99418 7.55591C7.2306 7.5241 7.33177 7.46918 7.39853 7.40243C7.46528 7.33568 7.52019 7.2345 7.55201 6.99808C7.58525 6.75065 7.58607 6.41889 7.58607 5.92505C7.58607 5.4312 7.58525 5.09945 7.55201 4.85201C7.52019 4.61561 7.46528 4.51443 7.39853 4.44768C7.33177 4.38092 7.2306 4.32599 6.99418 4.29421C6.74674 4.26093 6.41499 4.26012 5.92114 4.26012C5.4273 4.26012 5.09554 4.26093 4.8481 4.29421Z"
                  fill="white"
                />
              </svg>
            ) : (
              <svg
                width="10"
                height="11"
                viewBox="0 0 10 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.988281 5.50123V8.32158C0.988281 9.25637 2.01421 9.84727 2.84904 9.39328L4.14564 8.68818M0.988281 3.88199V2.68087C0.988281 1.74608 2.01421 1.15519 2.84904 1.60917L8.03546 4.42953C8.89443 4.89664 8.89443 6.10581 8.03546 6.57292L5.44225 7.98312"
                  stroke="white"
                  stroke-linecap="round"
                />
              </svg>
            )}
            {isTestStart ? 'Stop Test' : 'Start Test'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AITestRecording;
